import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withStyles, Grid } from '@material-ui/core';
import { UserCard, FHEContainer, FHEContainerScroll, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgSDM18MVR } from 'data/common/iconsvg';

import {
    getSDM18MVRDetails,
    refreshSDM18MVRStatus,
    switchSDM18MVRMaster,
    dissociateSDM18MVRUser,
    dissociateSDM18MVRUserAndSwitchMaster
} from '../../data/SDM18MVR/actions';

class SDM18MVRDetail extends PureComponent {
    static propTypes = {
        getSDM18MVRDetails: PropTypes.func.isRequired,
        dissociateSDM18MVRUser: PropTypes.func.isRequired,
        dissociateSDM18MVRUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSDM18MVRMaster: PropTypes.func.isRequired,
        refreshSDM18MVRStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        SDM18MVR: PropTypes.object,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        SDM18MVR: new Map()
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false
        };
    }

    componentDidMount() {
        this.getSDM18MVRDetails();
    }

    getSDM18MVRDetails = () => {
        const { getSDM18MVRDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getSDM18MVRDetails(match.params.SDM18MVRId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSDM18MVRMaster = (SDM18MVRMac, userId) => {
        const { switchSDM18MVRMaster } = this.props;

        return switchSDM18MVRMaster(SDM18MVRMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM18MVRUser = (SDM18MVRMac, userId) => {
        const { dissociateSDM18MVRUser } = this.props;

        return dissociateSDM18MVRUser(SDM18MVRMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM18MVRUserAndSwitchMaster = (SDM18MVRMac, userId, masterId) => {
        const { dissociateSDM18MVRUserAndSwitchMaster } = this.props;

        return dissociateSDM18MVRUserAndSwitchMaster(SDM18MVRMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    refreshStateSDM18MVR(SDM18MVRMac) {
        const { refreshSDM18MVRStatus } = this.props;
        return refreshSDM18MVRStatus(SDM18MVRMac)
            .then(() => {
                Toastr.success(Translator.translate('general.products.SDM18MVR.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('general.products.SDM18MVR.table.action.refresh.error')
                );
                throw err;
            });
    }

    renderUserList() {
        const { usersLoading, actionDisabled } = this.state;
        const { SDM18MVR, profile } = this.props;
        const users = [];

        if (!usersLoading && SDM18MVR.has('otherUsers')) {
            SDM18MVR.get('otherUsers').map(user => {
                const isMaster = SDM18MVR.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    SDM18MVR.get('otherUsers').map(user => {
                        if (user.get('_id') !== SDM18MVR.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={SDM18MVR}
                            productName="SDM18MVR"
                            environment="myfhe"
                            dissociateUserFunc={this.dissociateSDM18MVRUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSDM18MVRUserAndSwitchMaster}
                            switchMasterFunc={this.switchSDM18MVRMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }
    renderPartDetail = () => {
        const { SDM18MVR, classes } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.calibrated')}
                        itemContent={
                            SDM18MVR.get('calibrated')
                                ? Translator.translate('general.products.SDM18MVR.table.data.calibrated')
                                : Translator.translate('general.products.SDM18MVR.table.data.uncalibrated')
                        }
                        classContent={SDM18MVR.get('calibrated') ? classes.connectedColor : classes.disconnectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.position')} itemContent={SDM18MVR.get('position')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.position')} itemContent={SDM18MVR.get('position')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.mode')}
                        itemContent={Translator.translate(`general.data.mode.${SDM18MVR.get('mode')}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.planningMode')}
                        itemContent={Translator.translate(`general.data.planningMode.${SDM18MVR.get('planningMode')}`)}
                    />
                </Grid>
            </Grid>
        );
    };

    renderChildren = () => {
        const { loading } = this.state;
        const { SDM18MVR, classes } = this.props;
        return (
            <Fragment>
                <FHETitle title={SDM18MVR.get('label')} Icon={SvgSDM18MVR} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        SDM18MVR.get('macAddress')
                                            ? SDM18MVR.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={SDM18MVR.get('firmwareVersion')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.products.SDM18MVR.table.action.refresh.tooltip')}
                                    onClick={this.refreshStateSDM18MVR}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${SDM18MVR.get('state')}`)}
                                    classContent={SDM18MVR.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={SDM18MVR.get('userEmail')} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />

                    <FHEContainerForm loading={loading} onRender={this.renderPartDetail} />

                    <FHEDivider title={Translator.translate('general.Users')} />
                    {this.renderUserList()}
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSDM18MVRDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');

    let SDM18MVR = state.environments.myfhe.data.SDM18MVR.getIn(['list', props.match.params.SDM18MVRId], new Map());
    if (SDM18MVR && users) {
        let otherUsers = [];
        let masterUser = new Map();
        if (SDM18MVR.get('usersList')) {
            SDM18MVR.get('usersList').forEach(userId => {
                users.find(user => {
                    if (userId === user.get('_id')) {
                        if (masterUser.size === 0 && SDM18MVR.get('userMasterId') === user.get('_id')) {
                            masterUser = user;
                            otherUsers.unshift(user);
                        } else {
                            otherUsers.push(user);
                        }
                    }
                });
            });
            SDM18MVR = SDM18MVR.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
        }
    }
    return {
        profile: state.data.user,
        SDM18MVR,
        initialized: state.environments.myfhe.data.SDM18MVR.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                { getSDM18MVRDetails, refreshSDM18MVRStatus, switchSDM18MVRMaster, dissociateSDM18MVRUser, dissociateSDM18MVRUserAndSwitchMaster },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(SDM18MVRDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM18MVR/details.js